<template>
  <div class="addRow">
    <a
      href="#"
      class="addRow-link"
      @click.prevent="$emit('click')"
    >
      <span class="addRow-icon" />
      <span class="addRow-text">Добавить ряд</span>
    </a>
  </div>
</template>

<script>
  export default {
    name: 'AddRow',
  }
</script>

<style>
  .addRow {
    padding: 13px 24px;
    background: #F6F6F6;
  }
  .addRow-link {
    font-family: Oswald, Roboto, sans-serif;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    text-transform: uppercase;
    line-height: 24px;
    color: #0B53B3;
  }
  .addRow-icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
    width: 24px;
    height: 24px;
    background: #F58214 url(../../public/icons/sign_sm.svg) no-repeat center center;
  }
  .addRow-text {
    display: inline-block;
    vertical-align: middle;
  }
</style>
